// extracted by mini-css-extract-plugin
export default {"greyHeading":"globals_greyHeading__Unyua","standardSection":"globals_standardSection__aDP5Z","biggerSection":"globals_biggerSection__VwlSD"};